import React from 'react';
import { FileText, CheckCircle2, AlertTriangle } from 'lucide-react';

export function ArchitecturalAccessibility() {
  return (
    <div className="bg-white dark:bg-accessible-gray-800 high-contrast:bg-black p-8 rounded-lg shadow-lg">
      <div className="flex items-center gap-4 mb-6">
        <div className="w-12 h-12 rounded-full bg-accessible-red-600/10 flex items-center justify-center">
          <FileText className="w-6 h-6 text-accessible-red-600" aria-hidden="true" />
        </div>
        <h2 className="card-title">
          Dostępność architektoniczna
        </h2>
      </div>
      
      <div className="space-y-4">
        <div className="bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg">
          <h3 className="heading-5 mb-4">
            Siedziba Fundacji Znajdki
          </h3>
          <p className="body-medium">
            Krusze ul. Kryształowa 171, 05-240 Tłuszcz
          </p>
          <ul className="space-y-3 mt-4">
            <li className="flex items-start gap-2">
              <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
              <span className="body-medium no-margin">Teren schroniska jest płaski, bez wzniesień i schodów</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
              <span className="body-medium no-margin">Możliwe poruszanie się na wózku inwalidzkim</span>
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="w-5 h-5 text-accessible-red-600 flex-shrink-0 mt-1" />
              <span className="body-medium no-margin">Duży parking przed schroniskiem</span>
            </li>
            <li className="flex items-start gap-2">
              <AlertTriangle className="w-5 h-5 text-yellow-600 dark:text-yellow-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium no-margin">Siedziba administracyjna nie jest w pełni dostosowana dla osób niepełnosprawnych</span>
            </li>
            <li className="flex items-start gap-2">
              <AlertTriangle className="w-5 h-5 text-yellow-600 dark:text-yellow-400 high-contrast:text-white flex-shrink-0 mt-1" />
              <span className="body-medium no-margin">Brak toalety przystosowanej dla osób niepełnosprawnych</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}